import { atom, useAtom } from 'jotai/index';
import { IClaimMultiSignWallet } from 'types';

export const archivedSafesAtom = atom<IClaimMultiSignWallet[]>([]);

export const useArchivedSafes = () => {
  const [archivedSafes, setArchivedSafes] = useAtom(archivedSafesAtom);

  return {
    archivedSafes,
    setArchivedSafes,
  };
};
